/** A canvas kind is a flat identifier. Nothing here branches on which one it is. */

/** True for a kind namespaced under a publisher rather than a platform kind. */
export function namespaced(kind: string): boolean {
  return kind.includes(".");
}

/** The publisher prefix, or null for a platform kind. */
export function publisherOf(kind: string): string | null {
  return namespaced(kind) ? (kind.split(".")[0] ?? null) : null;
}

/** The kind's own name back. */
export function canvasLabel(kind: string): string {
  return namespaced(kind) ? kind.split(".").slice(1).join(".") : kind;
}
